// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioState__container-a70625 {
  position: relative;
}

.AudioState__icon-f53ac6 {
  position: absolute;
  left: 50%;
  top: 50%;
  max-width: 100%;
  max-height: 100%;
  transform: translate(-50%, -50%);
}

.AudioState__button-d4eb46 {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/main/components/AudioState/AudioState.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n}\n\n.icon {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  max-width: 100%;\n  max-height: 100%;\n  transform: translate(-50%, -50%);\n}\n\n.button {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioState__container-a70625`,
	"icon": `AudioState__icon-f53ac6`,
	"button": `AudioState__button-d4eb46`
};
module.exports = ___CSS_LOADER_EXPORT___;
